import { observable } from "mobx";
import { Type } from "class-transformer";
import NotifiableExemptionReason from "./notifiableExemptionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class NotifiableExemptionReasonSimpleList {
  id!: string;

  @observable
  description!: string;

  @observable
  exemptionReason!: NotifiableExemptionReason;

  @observable
  isDeleted!: boolean;

  @observable
  @Type(() => Date)
  validSinceDate?: Date;

  @observable
  @Type(() => Date)
  validUntilDate!: Date;
}
